import {DefaultErrorOverlay} from '@ael/shared-components-library';
import React from 'react';

export const ProjectNotAvailableErrorOverlay = () => {
  return (
    <DefaultErrorOverlay
      title="Course Unavailable"
      description={
        <p>
          Apologies, but the provided link has been deactivated and is now unavailable. Please get in touch with the
          course administrator for additional information.
        </p>
      }
    />
  );
};
